/** Hide the previous selection while Horizon requests the next variant.
 * Horizon replaces the gallery on variant:update; the new markup clears busy.
 * Restricted to the Samsung gallery; variant IDs and purchase logic stay native.
 */
document.addEventListener('change', (event) => {
  if (!(event.target instanceof HTMLSelectElement)) return;
  const picker = event.target.closest('variant-picker');
  const section = picker?.closest('.shopify-section');
  const gallery = section?.querySelector('media-gallery.bendly-samsung-gallery');
  if (gallery) gallery.setAttribute('aria-busy', 'true');
});
